import Api from './Api';
import Configuracao from '../util/Configuracao';

class CreditoApi extends Api {
  async recuperarEstrutura () {
    try {
      const estruturaCreditosUrl = Configuracao.getConfiguracao().urlEstruturaCredito;
      const response = await this.fetch(estruturaCreditosUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarCreditos (filter) {
    try {
      const consultarCreditosUrl = Configuracao.getConfiguracao().urlConsultarCreditos + '/' + filter.ano + '/tipo/' + filter.tipo;
      const response = await this.fetch(consultarCreditosUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async validarCredito (credito) {
    try {
      const validarCreditoUrl = Configuracao.getConfiguracao().urlValidarCredito;
      const response = await this.fetch(validarCreditoUrl, 'put', credito);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async cancelarCredito (codCredito) {
    try {
      const cancelarCreditoUrl = Configuracao.getConfiguracao().urlCancelarCredito + '/' + codCredito;
      await this.fetch(cancelarCreditoUrl, 'put');
    } catch (error) {
      console.error(error);
    }
  }

  async desfazerCancelamento (codCredito) {
    try {
      const desfazerCancelamentoCreditUrl = Configuracao.getConfiguracao().urlDesfazerCancelamentoCreditoUrl + '/' + codCredito;
      await this.fetch(desfazerCancelamentoCreditUrl, 'put');
    } catch (error) {
      console.error(error);
    }
  }

  async excluirCredito (codCredito) {
    try {
      const excluirCreditoUrl = Configuracao.getConfiguracao().urlExcluirCredito + '/' + codCredito;
      await this.fetch(excluirCreditoUrl, 'put');
    } catch (error) {
      console.error(error);
    }
  }

  async incluirCredito (credito) {
    try {
      const incluirCreditoUrl = Configuracao.getConfiguracao().urlIncluirCredito;
      await this.fetch(incluirCreditoUrl, 'put', credito); // , {'content-type': 'application/json'});
    } catch (error) {
      console.error(error);
    }
  }
  async alterarCredito (credito) {
    try {
      const alterarCreditoUrl = Configuracao.getConfiguracao().urlAlterarCredito;
      await this.fetch(alterarCreditoUrl, 'put', credito); // , {'content-type': 'application/json'});
    } catch (error) {
      console.error(error);
    }
  }
}

export default CreditoApi;
